var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"by-loader d-flex flex-column",staticStyle:{"justify-content":"center","align-items":"center"}},[_c('span',{staticClass:"loader"}),_c('strong',{staticClass:"mt-5",staticStyle:{"text-align":"center"}},[_vm._v(" "+_vm._s(_vm.message || _vm.$t("app.t.text89"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }